<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
    ></tables-page>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import reportApi from "@/models/API/reportApi";
import TablesPage from "@/components/layouts/TablesPage";

export default {
  name: 'salesAgeDistribution',
  components: {
    BreadCrumb,
    TablesPage
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '業務年齡層分布', url: '', isActive: false }
        ]
      },
      status: {
        contractModal: false
      },
      options: {
        year: [],
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "age",
            label: "年齡層",
          },
          {
            key: "M",
            label: "男"
          },
          {
            key: "F",
            label: "女"
          },
          {
            key: "total_people",
            label: "總人數",
          },
          {
            key: "percentage",
            label: "%",
          },
        ]
      },
    }
  },
  computed: {

  },
  mounted() {
    this.reportApi = new reportApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.getReportSalesAge();
    },
    // 取得業務年齡層
    getReportSalesAge() {
      this.reportApi.getReportSalesAge((response) => {
        const res = response.data;

        this.tableFormatHandler(res.data[0])
      })
    },
    // 表格格式整理
    tableFormatHandler(data) {
      const table_classified_data = {
        age_19: { age: '19歲以下(公司行號)', total_people: 0 },
        age_20_29: { age: '20－29歲', total_people: 0 },
        age_30_39: { age: '30 - 39歲', total_people: 0 },
        age_40_49: { age: '40 - 49歲', total_people: 0 },
        age_50_59: { age: '50 - 59歲', total_people: 0 },
        age_60_69: { age: '60 - 69歲', total_people: 0 },
        age_70_79: { age: '70 - 79歲', total_people: 0 },
        age_80_89: { age: '80 - 89歲', total_people: 0 },
        age_90_99: { age: '90 - 99歲', total_people: 0 },
        age_100: { age: '100歲以上', total_people: 0 },
        age_total: { age: '總計', total_people: 0 }
      };

      Object.entries(table_classified_data).forEach(([table_key, table_value]) => {
        this.data.table_fields.forEach(item => {
          const current_key = `${table_key}_${item.key}`;

          const current_total_M_value = data['age_total_M'];
          const current_total_F_value = data['age_total_F'];

          if (item.key === 'percentage') {
            table_classified_data[table_key][item.key] = `${(table_classified_data[table_key].total_people / (current_total_M_value + current_total_F_value) * 100).toFixed(1)}%`
          } else if (item.key !== 'age' && item.key !== 'total_people') {
            table_classified_data[table_key][item.key] = data[current_key];
            table_classified_data[table_key].total_people += data[current_key];
          }
        });
      })

      this.data.table_data = Object.values(table_classified_data);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/salesAgeDistribution.vue